import { render, staticRenderFns } from "./WhosOnFirst.vue?vue&type=template&id=79fd6dec&"
import script from "./WhosOnFirst.vue?vue&type=script&lang=js&"
export * from "./WhosOnFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports